import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Forms from "../../../../../Componets/Form";
import toast from "react-hot-toast";
import Header from "../../../../../Componets/Header";
import {
  create_account,
  get_account,
  update_account,
} from "../../../../../Controllers/Accounting/Services/chartOfAccountsService";
import forms from "../../../../../Data/Forms/Accounting/ChartOfAccount/forms";
import headers from "../../../../../Data/Forms/Accounting/ChartOfAccount/headers";
import Loadercomponent from "../../../../../Componets/Loader";

const ChartOfAccountsForm = () => {
  let { id } = useParams();
  let navigate = useNavigate();

  const [loader, setLoader] = useState(false);
  const [buttonLoader, setButtonLoader] = useState(false);
  const [header, setHeader] = useState(headers);
  const [values, setValues] = useState(forms);

  const getformdata = async (data) => {
    console.log("Form data changed:", data);
  };

  const formdata = async (data) => {
    if (data?.status) {
      setButtonLoader(true);

      console.log("Submitting form data:", data);

      try {
        const accountData = {
          ...data?.data,
          status: 1,
          isReceivable: data?.data?.isReceivable || false,
          isPayable: data?.data?.isPayable || false,
          isContraAccount: data?.data?.isContraAccount || false,
        };

        console.log("Processed account data for submission:", accountData);

        if (accountData.isContraAccount && !accountData.associatedaccounts) {
          setButtonLoader(false);
          toast.error("Associated Accounts is required when account is Contra");
          return;
        }

        const result = id
          ? await update_account({ id: id, ...accountData })
          : await create_account(accountData);

        if (result?.success) {
          navigate(-1);
          toast.success(
            result?.message ||
            (id
              ? "Account updated successfully"
              : "Account created successfully")
          );
          setButtonLoader(false);
        } else {
          setButtonLoader(false);
          if (result?.status_code === 403) {
            window.location.href = "/unauthorized";
          } else {
            toast.error(
              result?.message ||
              (id ? "Failed to update account" : "Failed to create account")
            );
          }
        }
      } catch (error) {
        setButtonLoader(false);
        toast.error(
          error.message ||
          (id ? "Failed to update account" : "Failed to create account")
        );
      }
    }
  };

  const handleData = (account) => {
    const updatedForms = [...forms];

    updatedForms[0].options[0].form.value = account?.name || "";
    updatedForms[0].options[1].form.value = account?.code || "";
    updatedForms[0].options[2].form.value = account?.description || "";
    updatedForms[0].options[3].form.value = account?.balance || "";

    updatedForms[1].options[0].form.value = account?.type || null;
    updatedForms[1].options[1].form.value = account?.category || null;

    updatedForms[2].options[0].form.value = account?.isContraAccount || false;
    updatedForms[2].options[1].form.value = account?.associatedaccounts || null;

    if (account?.isContraAccount && account?.contraAssociatedAccounts) {
      updatedForms[2].options[1].form.value =
        account.contraAssociatedAccounts[0].name;
    }

    updatedForms[2].options[2].form.value = account?.isReceivable || false;
    updatedForms[2].options[3].form.value = account?.isPayable || false;

    updatedForms[3].options[0].form.value =
      account?.subAccounts !== undefined ? account.subAccounts : 1;

    updatedForms[4].options[0].form.value =
      account?.status !== undefined ? account.status : 1;

    setValues(updatedForms);
    setLoader(false);
  };

  const fetchData = async () => {
    if (id) {
      setLoader(true);

      try {
        const data = {
          id: id,
        };

        const account = await get_account(data);

        if (account?.success) {
          handleData(account?.data);
        } else {
          toast?.error(account?.message || "Failed to fetch account data");
          setLoader(false);
        }
      } catch (error) {
        toast?.error("Error fetching account data");
        setLoader(false);
      }
    } else {
      setLoader(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [id]);

  return (
    <Header headers={header} setHeaders={setHeader} formdata={formdata}>
      <Loadercomponent loader={loader}>
        <Forms
          form={values}
          setForm={setValues}
          formdata={formdata}
          buttonLoader={buttonLoader}
          getformdata={getformdata}
        />
      </Loadercomponent>
    </Header>
  );
};

export default ChartOfAccountsForm;
